module.exports = __webpack_public_path__ + "static/media/check-mark-green.b7371ebc.svg";